import actionTypes from './actionTypes';

/**
 * Adds the css library name
 *
 * @param {string} cssLibraryName Default css library name
 * @return {Object} Action object
 */
export function setDefaultCssLibrary(cssLibraryName) {
  return {
    type: actionTypes.SET_DEFAULT_CSS_LIBRARY,
    cssLibraryName,
  };
}
